import "core-js/modules/es.date.to-string.js";
export default {
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
};